export default {
  MiddleNameFormField__ARIA: "Middle name",
  MiddleNameFormField__LABEL: "Middle name",
};
